<template>
  <a-drawer
      :visible="visible"
      :title="title"
      width="60%"
      destroyOnClose
      @close="onClose">
    <div>
      <From
        ref="formRef"
        layoutType="grid"
        :isErrorMessage="false"
        :optionList="formRow"
        :formRules="formRules"
        :defaultModel="defaultModel"
      >
      </From>
    </div>
    <div class="footer-but" v-if="!readonly">
        <a-button style="marginRight: 8px" @click="onClose">
          取消
        </a-button>
        <a-button class="first-but" type="primary" @click="handleOk">
          确定
        </a-button>
    </div>
  </a-drawer>
</template>

<script>
import { mapState } from 'vuex'
import {is_cloneDeep} from '@/utils/cloneDeep.js'
//addUser
import {getRoleList, addUser, getUserById, updateUser} from '@/api/back.js'
import {formRows, formRules} from './modal.js'
import From from '@/views/Back/components/formTable/form.vue'
export default {
    props: {
        deptId: {
            type: Number,
            default: null
        },
        id: {
            type: Number,
            default: null
        },
        readonly: {
            type: Boolean,
            default: false
        },
        visible: {
            type: Boolean,
            default: false
        }
    },
    components: {From},
    data() {
        return {
            title: '新增',
            formRow: [],
            formRules, // 表单校验规则配置
            defaultModel: {}, // 表单的默认值
            roleList: []
        }
    },
    computed: {
        ...mapState({
            treeData: state => state.back.deptTree
        })
    },
    watch: {
      visible: {
          handler(n) {
              if(n) {
                  this.formRow = is_cloneDeep(formRows)
                    this.formRow.forEach((item, i) => {
                    if(item.prop === 'roleIds') {
                        this.$set(this.formRow[i], 'list', this.roleList)
                    }
                    if (item.prop === 'deptId') {
                        this.$set(this.formRow[i], 'list', this.treeData)
                    }
                    if(this.readonly) {
                        this.$set(this.formRow[i], 'disabled', true)
                    }
                    if(this.id && (item.prop === 'userName' || item.prop === 'password')) {
                        this.$set(item, 'disabled', true)
                    }
                    })
                    this.defaultModel = {
                      useStatus: true
                    }
                    if(this.id) {
                        //getData
                        this.formRow.splice(3,1)
                        this.getUserById(this.id)
                        this.title = this.readonly ? '详情' : '编辑'
                    }
              }
          }
      }
    },
    created() {
        this.getRoleList()
    },
    methods: {
        async getRoleList() {
            const {rows} = await getRoleList({pageNum: 1, pageSize: 100})
            rows.forEach(item => {
                item.value = item.roleId
                item.label = item.roleName
            })
            this.roleList = rows
        },
        async getUserById(id) {
            const {data, roleIds} = await getUserById(id)
            console.log('data', data)
            roleIds.forEach(item => item + '')
            const {userName, useStatus, phonenumber, deptId, email, nickName} = data
            this.defaultModel = {
              userName,
              useStatus: useStatus === '0' ? true : false,
              phonenumber,
              email,
              deptId: deptId + '',
              nickName,
              roleIds
            }
        },
        async handleOk() {
            const v1 = this.$refs.formRef.validatedForm()
            const refD = this.$refs.formRef.formModel
            if (!v1) {return false}
            if(refD.useStatus) {
                refD.useStatus = 0
            } else {
                refD.useStatus = 1
            }
            refD.deptId = refD.deptId + ''
            const res = this.id ? await updateUser({...refD, id: this.id})  : await addUser(refD)
            if (res.code === 200) {
                this.$message.success(res.msg)
                this.reset()
                this.$emit('ok')
            } else {
                this.$message.error(res.msg)
            }
        },
        onClose() {
            this.reset()
            this.$emit('cancel')
        },
        reset() {
            this.title = '新增',
            this.defaultModel = {
              useStatus: true
            }
        },
        getData() {}
    }
}
</script>

<style lang="scss" scoped>
</style>